import { render } from "./PrismaIcon.vue?vue&type=template&id=4634e832&scoped=true"
import script from "./PrismaIcon.vue?vue&type=script&lang=js"
export * from "./PrismaIcon.vue?vue&type=script&lang=js"

import "./PrismaIcon.vue?vue&type=style&index=0&id=4634e832&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4634e832"]])

export default __exports__